import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Text, Linking } from "react-native";

import { HELP_DESK_URL } from "apis";
import { Background, Card } from "components";

import { styles } from "./styles";

class Expired extends Component {
  render = () => {
    const { message } = this.props;

    return (
      <Background style={styles.background}>
        <Card style={styles.card}>
          <View style={styles.container}>
            <Text style={[styles.text, styles.h2]}>{message}</Text>
          </View>
        </Card>
      </Background>
    );
  };
}

const mapStateToProps = state => {
  return {
    message: state.survey.message,
  };
};

export default connect(mapStateToProps)(Expired);
